import { createContext, useEffect, useState, useContext } from "react";
import useDataApi from "../hooks/useDataApi";
import { fnGetColors } from "../services/colors";
import PaineisContext from "./Paineis";

export const ColorsContext = createContext(null);

export const ColorsContextProvider = ({ children }) => {
  const [oColorsRes, fnGetColorsReq] = useDataApi(fnGetColors);
  const [aDepartamentColors, fnSetADepartamentColors] = useState([])
  const [oCurrentDepartamentColors, fnSetOCurrentDepartamentColors] = useState(null)

  const { oCurrentPanel } = useContext(PaineisContext)

  useEffect(() => {
    if (aDepartamentColors?.length > 0) return
    (async () => {
      await fnGetColorsReq()
    })()
  }, [])

  useEffect(() => {

    if (
      oColorsRes.done
    ) {
      fnSetADepartamentColors(oColorsRes?.data?.data ?? [])
    }
  }, [oColorsRes])

  useEffect(() => {
    if (!oCurrentPanel || !aDepartamentColors?.length) {
      fnSetOCurrentDepartamentColors(null)
      return
    }

    const oColors = aDepartamentColors.find(
      (c) => c?.opc_nid === oCurrentPanel?.color_id,
    )
    fnSetOCurrentDepartamentColors(oColors)
  }, [oCurrentPanel, aDepartamentColors])

  return (
    <ColorsContext.Provider
      value={{ aDepartamentColors, oColorsRes, oCurrentDepartamentColors }}
    >
      {children}
    </ColorsContext.Provider>
  )
}